import { render, staticRenderFns } from "./IcoDesktopMobileDevice.vue?vue&type=template&id=d4773d0a"
import script from "./IcoDesktopMobileDevice.vue?vue&type=script&lang=js"
export * from "./IcoDesktopMobileDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports